module.exports = __webpack_public_path__ + "static/media/device-info-pl.a7f4db74.png";